export default "__VITE_ASSET__DD8pbQz6__"